import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './components/app.jsx';
import './styles.css';

// 把真实视口宽度写到 CSS 变量 --actual-vw（一些 100vw 算的不准的环境兜底）
function syncViewportWidth() {
  document.documentElement.style.setProperty('--actual-vw', window.innerWidth + 'px');
}
syncViewportWidth();
window.addEventListener('resize', syncViewportWidth);

createRoot(document.getElementById('root')).render(<App />);
